import { Card } from "@components/cards/card";
import { RaffleDefaultNumberRewards } from "@components/raffles/default/number/rewards";
import { IRaffleDefaultRewardDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { api } from "@service/api";
import { useEffect, useState } from "react";
import { FiAward } from "react-icons/fi";
import Skeleton from "react-loading-skeleton";

interface IProps { raffleKey: string; campaign?: string; }

export const RaffleRewardVisitor = ({ raffleKey, campaign }: IProps) => {
  const { actions: { pushToastify } } = ZuToastifyStore();
  const [rewards, setRewards] = useState<IRaffleDefaultRewardDTO[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get("/raffleClient/default/rewards", { params: { campaign, key: raffleKey } })
      .then(({ data }) => { if (active) setRewards(data || []); })
      .catch((error) => {
        if (active) pushToastify({ message: error?.response?.data?.message || "Falha ao carregar os prêmios.", type: "error", theme: "dark" });
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [raffleKey, campaign, pushToastify]);

  return (
    <Card className="visit-panel visit-rewards">
      <div className="visit-section-heading"><div className="visit-heading-icon visit-heading-award"><FiAward /></div><div><h2>Prêmios da campanha</h2><p>Conheça os prêmios e explore todas as fotos e vídeos.</p></div></div>
      {loading ? <Skeleton count={3} height={60} /> : <RaffleDefaultNumberRewards rewards={rewards} />}
    </Card>
  );
};
